import { defineStore }                                           from 'pinia'
import { ref, computed, shallowRef, inject, watch, watchEffect } from "vue";
import { useRoute, useRouter }                                   from "vue-router";
import axios                                                     from "axios";
// import { loadStripe }                                            from '@stripe/stripe-js';
import { v4 as uuidv4 }                                          from 'uuid';
import { useLocalStorage }                                       from "@vueuse/core"
import { dispatchWindowEvent }                                   from '../composables/utils';


export const useMainStore = defineStore( 'main', () =>
{
    let router = useRouter();
    let route  = useRoute();

    const copydeck = shallowRef( [] );
    copydeck.value = inject( 'copydeck' );

    const gstRate = shallowRef( 0 );
    gstRate.value = parseFloat( copydeck?.value?.payment?.tax_rate_gst?.fr ?? 0.05 );

    const qstRate = shallowRef( 0 );
    qstRate.value = parseFloat( copydeck?.value?.payment?.tax_rate_qst?.fr ?? 0.09975 );

    const giftCardAd = shallowRef( [] );
    giftCardAd.value = inject( 'giftCardAd' );

    const giftCardThemes = shallowRef( [] );
    giftCardThemes.value = inject( 'giftCardThemes' );


    const productGroups = shallowRef( [] );
    productGroups.value = inject( 'productGroups' );

    const productByMail = shallowRef( {} );
    productByMail.value = inject( 'productByMail' );


    // this is actually based on the other products in the group in the form
    const customGiftCardGroupIndex = shallowRef( [] );
    customGiftCardGroupIndex.value = 2;

    const customGiftCardFellowProductsGroupIndex = shallowRef( [] );
    customGiftCardFellowProductsGroupIndex.value = 1;

    const onlyProducts = computed( () => productGroups.value.reduce( ( a, group ) => [ ...a, group.products ], [] ).flat() )

    const lang = shallowRef( [] );
    lang.value = inject( 'lang' );

    // const stripePublicKey = ref("");
    // stripePublicKey.value = inject("pkStripe");


    const strSessionPrefix        = "lasource-giftcard-"
    const objProductByMail           = {id_product: productByMail.value.id, quantity: 0, groupIndex: -1, isDeliveryByMail: true};
    let orders                    = ref( useLocalStorage( strSessionPrefix + 'orders', [objProductByMail] ) );
    const pending                 = ref( useLocalStorage( strSessionPrefix + 'pending', [] ) );
    const delivery                = ref( useLocalStorage( strSessionPrefix + 'delivery', {
        method                       : giftCardThemes.value[ 0 ].id,
        onePerson                    : true,
        needShippingAddress          : false,
        need_different_email_address : false,
        deliveredTo                  : [],
    } ) );
    let deliveryIsMail            = computed( () => [ "mail" ].includes( delivery.value.method ) );
    let deliveryIsEmail           = computed( () => ![ "mail" ].includes( delivery.value.method ) );
    let oneEmailDeliveryRecipient = ref( useLocalStorage( strSessionPrefix + 'oneEmailDeliveryRecipient', true ) );
    let shipToInvoiceAddress      = ref( useLocalStorage( strSessionPrefix + 'shipToInvoiceAddress', true ) );
    let emailToInvoiceEmail       = ref( useLocalStorage( strSessionPrefix + 'emailToInvoiceEmail', true ) );
    const invoice                 = ref( useLocalStorage( strSessionPrefix + 'invoice', {} ) );
    const shipping                = ref( useLocalStorage( strSessionPrefix + 'shipping', {} ) );
    const payment                 = ref( useLocalStorage( strSessionPrefix + 'payment', {} ) );
    const creditcard              = ref( {} );
    const paymentConfirmation     = ref( {} );

    const paymentIntent = ref( {} );
    const lastPage      = ref( useLocalStorage( strSessionPrefix + 'lastPage', "Introduction" ) );

    let stripe;
    //let stripeError = ref ( {})
    let elements;
    let cardNumber;
    let cardExpiry;
    let cardCvc;

    // async function activateStripe (strSelectorNumber, strSelectorExpiry, strSelectorCvc)
    // {
    //     if (orderCount.value > 0)
    //     {
    //
    //         stripe = await loadStripe(stripePublicKey.value);
    //
    //         elements = stripe.elements()
    //
    //         let elementStyles = {
    //             base: {
    //                 color: '#161616',
    //                 fontWeight: 400,
    //                 fontFamily: 'PT Sans,sans-serif',
    //                 fontSize: '16px',
    //                 textAlign: 'left',
    //                 lineHeight: '1.2',
    //                 fontSmoothing: 'antialiased',
    //
    //                 '::placeholder': {
    //                     color: '#161616',
    //                 },
    //                 ':-webkit-autofill': {
    //                     color: '#161616',
    //                 },
    //             },
    //             invalid: {
    //                 color: '#f63e3e',
    //
    //                 '::placeholder': {
    //                     color: '#f63e3e',
    //                 },
    //             },
    //         };
    //
    //         cardNumber = elements.create("cardNumber", {
    //             showIcon:    true,
    //             style: elementStyles,
    //             placeholder: copydeck.value.component_payment.txt_secure_credit_card_number[lang.value]
    //         });
    //         cardNumber.mount(strSelectorNumber);
    //
    //         cardExpiry = elements.create("cardExpiry", {
    //             style: elementStyles
    //         });
    //         cardExpiry.mount(strSelectorExpiry);
    //
    //         cardCvc = elements.create("cardCvc", {
    //             style: elementStyles
    //         });
    //         cardCvc.mount(strSelectorCvc);
    //     }
    // }


    const ready = ref( false );

    function getProductById ( id, path = "" )
    {
        let product = onlyProducts.value.find( p => p.id === id );

        if ( !product )
        {
            if (id === productByMail.value.id)
            {
                product = productByMail.value;
            }

        }

        if ( path === "" )
            return product;

        if ( product[ path ][ lang.value ] ) //is localized
            return product[ path ][ lang.value ];

        return product[ path ];
    }

    function clearPending ( groupIndex = -1 )
    {

    }

    function getProductByMail ( )
    {
        return productByMail.value;
    }

    function setQuantityByMail ( quantity )
    {
        let byMailIndex = orders.value.findIndex ( o => o.id_product === productByMail.value.id);
        orders.value[byMailIndex].quantity = quantity;
    }

    function addPendingToOrders ( groupIndex )
    {
        // const pendingToAdd = pending.value.filter( p => p.groupIndex === groupIndex );
        // MB 2023-10-31 : removed the filter so that it simply adds AL pending
        const pendingToAdd = pending.value;
        pending.value = [];

        const len = pendingToAdd.length;

        for ( let i = 0; i < len; i++ )
        {
            let orderPending = pendingToAdd[ i ];

            // if ( !orderPending ) //2024-02-08 MT - This is not working
            //     continue;

            let id_product = orderPending.id_product;

            //let productOrderIndex = orders.value.findIndex( o => o.id_product === id);
            let productOrderIndex = orders.value.findIndex( o => o.id_product === id_product );

            if ( productOrderIndex === -1 )
            {
                //orders.value.push( Object.assign({ id_product: id }, details));
                let quantity   = orderPending.quantity;
                let groupIndex = orderPending.groupIndex;

                // if we're dealing with the custom gift card
                if ( typeof orderPending.price !== 'undefined' )
                {
                    const price = orderPending.price;

                    orders.value.push( { id_product, quantity : 1, groupIndex, price } );
                } else
                {
                    if ( typeof orderPending.customGiftCard !== 'undefined' && orderPending.customGiftCard )
                    {

                        if ( quantity < 25 )
                        {

                            return;
                        }
                    }


                    let toAdd = { id_product, quantity, groupIndex };
                    if ( typeof orderPending.customGiftCard !== 'undefined' && orderPending.customGiftCard )
                    {
                        toAdd.customGiftCard = true;
                    }

                    orders.value.push( toAdd );
                }
            } else
            {
                //let po = orders.value[productOrderIndex];
                let po = orders.value[ productOrderIndex ];

                if (po.customGiftCard)
                {
                    let quantity   = orderPending.quantity;
                    let groupIndex = orderPending.groupIndex;
                    let toAdd = { id_product, quantity, groupIndex };
                    if ( typeof orderPending.customGiftCard !== 'undefined' && orderPending.customGiftCard )
                    {
                        toAdd.customGiftCard = true;
                    }

                    orders.value.push(toAdd);
                    continue;
                }

                // 2023-08-25 MB: Retiré car ça doublait l'ajout au total du cert cadeau
                // po.quantity += orderPending.quantity;

                // if we're dealing with the custom gift card
                if ( typeof orderPending.price !== 'undefined' )
                {
                    po.price = orderPending.price;
                }
                else
                {

                    /**
                     * 2023-08-25 MB : It was possible to add 9 quantity (the limit) but
                     * also come back and add 9 more as many times as you wanted.
                     *
                     * This way, we have a ceiling of 9
                     */
                    const totalQuantityTest = po.quantity + orderPending.quantity;

                    if ( totalQuantityTest > 9 )
                    {
                        po.quantity = 9
                    } else
                    {
                        po.quantity = totalQuantityTest
                    }
                }


            }

            if ( typeof window.gtag !== 'undefined' )
            {

                const product = onlyProducts.value.find( oP => oP.id === id_product );

                window.gtag( 'event', 'added_to_cart', {
                    'product'   : product?.name?.fr ?? product?.name?.en ?? 'Unknown product',
                    'productId' : id_product,
                    'quantity'  : orderPending.quantity,
                } );
            }

            // this doesn't handle the custom gift cards.. but I don't think it matters
            orderPending.quantity = 0;


        }


        dispatchWindowEvent('la-source-cart-changed', { numItems : orderCount.value })
    }


    function getOrderById ( id, pOrders, index = 0 )
    {
        const order = pOrders.find( o => o.id_product === id );

        return order;
    }

    function getOrderPrice ( currentOrder,  pOrders, )
    {
        if (currentOrder.customGiftCard)
        {
            return currentOrder.quantity;
        }

        const price = getProductById( currentOrder.id_product, "price" );
        const order = getOrderById( currentOrder.id_product, pOrders );

        const total = parseFloat( price ) * parseInt( order.quantity );

        return total;

    }

    function getSubtotal ( pOrders )
    {
        let subtotal = pOrders.reduce( ( a, o ) => a + getOrderPrice( o, pOrders ), 0 );

        // if ( deliveryIsMail.value )
        // {
        //     subtotal += 3;
        // }

        return roundTo(subtotal, 2 );
    }

    function getTaxableSubtotal ( pOrders )
    {
        const taxable = pOrders.filter( o => getProductById( o.id_product ).taxable !== 0 );
        let subtotal  = taxable.reduce( ( a, o ) => a + getOrderPrice( o, pOrders ), 0 );

        // if ( deliveryIsMail.value )
        // {
        //     subtotal += 3;
        // }

        return roundTo(subtotal, 2 );
    }

    function getGst ( pOrders )
    {
        const taxableSubtotal = getTaxableSubtotal( pOrders );
        const gst             = (taxableSubtotal * gstRate.value);

        return gst;
    }

    function getQst ( pOrders )
    {
        const taxableSubtotal = getTaxableSubtotal( pOrders );
        const qst             = (taxableSubtotal * qstRate.value);

        return qst;
    }

    //using only toFixed was causing rounding issues
    function roundTo(n = 0, decimals = 2) {
        return Math.round(n * 10**decimals) / 10**decimals;
    }

    function getOrderTotal ( pOrders )
    {
        const subtotal = getSubtotal( pOrders );
        const gst      = getGst( pOrders );
        const qst      = getQst( pOrders );

        let total = (parseFloat( subtotal ) + parseFloat( gst ) + parseFloat( qst ));
        total = roundTo( total, 2 );
        return total;
    }

    let orderCount = computed( () => orders.value.reduce( ( a, o ) => a + (o.isDeliveryByMail ? 0 : (o.customGiftCard ? 1 :  o.quantity)), 0 ) );
    let hasOrder   = computed( () => orderCount.value > 0 );

    async function createPaymentIntent ()
    {
        const total = getOrderTotal();

        const payload  = { orders : orders.value, total };
        const response = await axios.post( "/endpoints/payment/create-intent", payload )

        if ( response.data.success === false )
        {
            return false;
        }

        paymentIntent.value = response.data;

        return true;

    }

    async function validatePaymentForm ( payload )
    {
        const response = await axios.post( "/endpoints/payment/validate", payload );

        return response.data;
    }

    async function processPayment ( onePerson, orders )
    {
        const processed = await processOrder( onePerson, orders );

        return processed;
    }

    async function processStripe ()
    {
        if ( !stripe )
        {
            console.log( "well tahta sucks" );
        }

        let cs   = { clientSecret : paymentIntent.value.cs };
        elements = stripe.elements( cs )


        let payload = {
            payment_method :
                {
                    card : cardNumber,

                    billing_details :
                        {
                            name : invoice.value.firstname + " " + invoice.value.lastname,

                        },
                    metadata        :
                        {
                            description : "Order #" + paymentIntent.value.order,
                        },
                },
        };

        try
        {
            const stripeConfirmation = await stripe.confirmCardPayment( paymentIntent.value.cs, payload );

            if ( stripeConfirmation.error )
            {
                stripeError.value = stripeConfirmation.error;
                return false;
            }

            const processed = processOrder( stripeConfirmation );

        }
        catch (e)
        {
            return false;
        }

        return true;
    }

    async function processOrder ( onePerson, pOrders )
    {
        const total = getOrderTotal( pOrders );

        delivery.value.onePerson = onePerson;

        const order    = {
            total,
            orders     : pOrders,
            invoice    : invoice.value,
            payment    : payment.value,
            creditcard : creditcard.value,
            delivery   : delivery.value,
            shipping   : shipping.value,
            lang       : lang.value,

        }
        const response = await axios.post( "/endpoints/payment/process", order )
        //const response = await axios.post("/endpoints/payment/process", {order, confirmation: stripeConfirmation, oid: paymentIntent.value.order}) //that was used for stripe

        if ( response.data.success !== false )
        {
            paymentConfirmation.value = response.data.confirmation;
        }


        return response.data;
    }

    function copyAndClearSession ()
    {
        const cOrders   = JSON.parse( JSON.stringify( orders.value ) );
        const cDelivery = Object.assign( {}, delivery.value );
        const cInvoice  = Object.assign( {}, invoice.value );
        clearSession();

        return { orders : cOrders, delivery : cDelivery, invoice : cInvoice }
    }

    function clearSession ()
    {
        orders.value                    = [objProductByMail];
        pending.value                   = [];
        oneEmailDeliveryRecipient.value = true;
        shipToInvoiceAddress.value      = true;
        invoice.value                   = {};
        shipping.value                  = {};
        payment.value                   = {};
        lastPage.value                  = "Introduction";
        delivery.value                  = {
            method              : "email",
            onePerson           : true,
            needShippingAddress : false,
            deliveredTo         : [],
        };
    }

    function getFirstThemeId ()
    {
        return giftCardThemes.value[ 0 ].id ?? 0;
    }

    let routeName = computed( () => route?.name ?? '' )

    watch( routeName, ( newVal, oldValue ) =>
    {
        lastPage.value = newVal;
    } )


    // function addToOrder ( id_product, quantity, groupIndex )
    // {
    //     let objByMail = {
    //         id_product,
    //         quantity,
    //         groupIndex,
    //     }
    //     console.log("orders addToOrder before", orders.value.length)
    //     orders.value.push (objByMail)
    //     console.log("orders addToOrder after", orders.value.length)
    // }
    //
    // function removeFromOrder ( id_product )
    // {
    //     console.log("orders removeFromOrder before", orders.value.length)
    //     orders.value = orders.value.filter ( o => o.id_product !== id_product);
    //     console.log("orders removeFromOrder after", orders.value.length)
    // }
    //
    // let backdoor = ref(0);
    //
    // watch (orders.value, (newVal, oldValue) => {
    //
    //     backdoor++;
    //     console.log("orders changed", newVal.length, oldValue.length)
    // })

   // const sortedOrders = computed( () => orders.value.filter( o => o.quantity > 0 ).sort( ( a, b ) => a.id - b.id ));

    const sortedOrders = computed(() =>
    {
        const result = orders.value.filter(o => o.quantity > 0).sort((a, b) => a.id_product - b.id_product);

        return result;
    });

    let sections = {
        "introduction": {fr: "introduction", en: "introduction"},
        "privacy": {fr: "confidentialite", en: "privacy"},
        "confidentialite": {fr: "confidentialite", en: "privacy"},
        "order": {fr: "commande", en: "order"},
        "commande": {fr: "commande", en: "order"},
        "recap": {fr: "recapitulatif", en: "recap"},
        "recapitulatif": {fr: "recapitulatif", en: "recap"},
        "info": {fr: "coordonnees", en: "info"},
        "coords": {fr: "coordonnees", en: "coords"},
        "coordonnees": {fr: "coordonnees", en: "coords"},
        "confirmation": {fr: "confirmation", en: "confirmation"},

    };

    let routerName = {
        "introduction": "Introduction",
        "privacy": "Privacy",

        "order": "Order",

        "recap": "Recap",
        "coords": "Coords",
        "confirmation": "Confirmation",

    };

    let meaningless = {fr: "cartes-cadeaux", en: "gift-cards"};

    function changeLang ()
    {
        //

        let params = route.params;
        let currentLang   = params.lang;
        let section = params.section;

        let otherLang = currentLang === "fr" ? "en" : "fr";
        let otherMeaningless = meaningless[otherLang];
        let otherSection = sections[section][otherLang];

        router.replace (
            {
                name: route.name,
                params: {lang: otherLang, meaningless: otherMeaningless, section: otherSection}
            }
        )

        //lang.value = otherLang; //since the header footer are in laravel, we don't need to change the lang here


        setTimeout( () => window.location.reload(), 500);

    }


    function getRoute (where)
    {
        let params = route.params;
        let currentLang   = params.lang;
        let section = params.section;

        let currentMeaningless = meaningless[currentLang];
        let whereSection = sections[where][currentLang];

        return {
            name: routerName[where],
            params: {lang: currentLang, meaningless: currentMeaningless, section: whereSection}
        }
    }

    function getOtherUrl ()
    {
        return lang.value === "fr" ? "/en/fartfart" : "/fr/pouetpouet";
    }

    return {

        paymentConfirmation,
        copydeck,
        creditcard,
        delivery,
        invoice,
        shipping,
        lang,
        deliveryIsMail,
        deliveryIsEmail,
        oneEmailDeliveryRecipient,
        shipToInvoiceAddress,
        emailToInvoiceEmail,
        onlyProducts,
        orders,
        hasOrder,
        orderCount,
        payment,
        pending,
        productGroups,
        route,
        routeName,
        router,
        sortedOrders,
        lastPage,

        giftCardAd,
        giftCardThemes,
        customGiftCardFellowProductsGroupIndex,
        customGiftCardGroupIndex,
        productByMail,

        //stripeError,
        //stripePublicKey,

        //activateStripe,

        addPendingToOrders,
        clearSession,
        changeLang,
        copyAndClearSession,
        gstRate,
        qstRate,
        getFirstThemeId,
        getGst,
        getQst,
        getOrderPrice,
        getOrderTotal,
        getOtherUrl,
        getProductById,
        getRoute,

        getSubtotal,
        getTaxableSubtotal,

        createPaymentIntent,
        processOrder,
        //processStripe,
        processPayment,
        roundTo,
        setQuantityByMail,
        validatePaymentForm,
    };
} )
